// @flow
export default function getServiceProviderIdFromParams(params: {
  // support known createRoutes params used for serviceProvideId
  serviceProviderId?: string,
  spId?: string,
  requestorId?: string,
} = {}): ?string {
  return params.serviceProviderId || params.spId || params.requestorId || null;
}



// WEBPACK FOOTER //
// ./src/app/common/serviceProvider/getServiceProviderIdFromParams.js